export default __webpack_public_path__ + "static/media/select-centre.90c0c577.png";